module.exports = "../dist/img/img_1-34.706c.jpg";